<template>
    <div class="border-0">
        
        <app-overlay-loader v-if="preloader"/>
        <div class="">
            <form ref="form" 
                  :data-url='selectedUrl ? `/admin/app/checklist/${checklistId}` : `/admin/app/checklist`' class="mb-0" 
                  :class="{'loading-opacity': preloader}">
                <div class="form-group form-group-comment align-items-center justify-content-end">
       
                    <app-input type="checkbox" :list="[{id:1, value: ''}]" v-model="inputs.status"/>
                    <app-input id="textarea_field"
                               class="w-100 textarea"
                               type="textarea"
                               :placeholder="$t('text_of_your_task')"
                               @blur="hiddenSubmit()"
                               v-model="inputs.name"/>
                    
                    
                    
                    <button v-if="!selectedUrl" type="submit" class="btn btn-primary btn-sm" @click.prevent="submit">
                        {{ $t('submit_comment') }}
                    </button>
                    
                </div>
                
            </form>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../../core/mixins/form/FormMixin.js';
    import GlobalHelperMixin from '../../../../../../Mixins/global/GlobalHelperMixin';

    export default {
        name: "InputFields",
        mixins: [FormMixin, GlobalHelperMixin],
        props: {
           selectedUrl: String,
           candidateId: String,
           checklistId: Number,
           userName: String,
           type: Number
        },
        data() {
            return {
                preloader: false,
                inputs: {
                    status: {id: '1', value: 'Hlavní město Praha', checked: true},
                },
                tableChecklistId: 'checklist-table',
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            hiddenSubmit() {
                if(this.selectedUrl){
                    this.submit();
                }
                
            },
            submit() {
                this.scrollToTop(true);
                
                console.log(this.inputs.status+' test');
                
                if(this.inputs.status = 1){
                    this.inputs.status = 1;
                } else {
                    this.inputs.status = 2;
                }
                
                
                
                if (this.inputs.name){
                    //this.inputs.status = 1;
                    this.inputs.candidate_id = this.candidateId;
                    this.inputs.author_name = this.userName;
                    this.inputs.type = 1;
                    this.inputs.timeline_state = 1;                    
                }
                
                this.save(this.inputs);
            },
            afterSuccessFromGetEditData(response) {
                console.log(response.data+' abc');
                // Fill other fields
                this.inputs = response.data;
                
            },
            afterFinalResponse() {
                this.preloader = false;
                this.$hub.$emit('reload-'+this.tableChecklistId);
                this.scrollToTop(false);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                // this.inputs = {};
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>
